// src/components/admin/SalesList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../styles/Admin/Sales.css';

const SalesList = () => {
  const [sales, setSales] = useState([]);
  const [summary, setSummary] = useState({ totalSales: 0, todaySales: 0 });
  const [filters, setFilters] = useState({ date: '', month: '', customer: '' });
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSales();
    fetchSummary();
  }, []);

  const fetchSales = async (filterParams = {}) => {
    try {
      const response = await axios.get('/api/sales/filter', { params: filterParams });
      setSales(response.data);
    } catch (error) {
      setError('Error fetching sales data');
    }
  };

  const fetchSummary = async () => {
    try {
      const response = await axios.get('/api/sales/summary');
      setSummary(response.data);
    } catch (error) {
      setError('Error fetching sales summary');
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchSales(filters);
  };

  return (
    <div className="sales-list">
      <h2>Sales Records</h2>
      {error && <p className="error">{error}</p>}

      <div className="sales-summary">
        <p>Total Sales: {summary.totalSales}</p>
        <p>Today's Sales: {summary.todaySales}</p>
      </div>

      <div className="sales-filters">
        <form onSubmit={handleFilterSubmit}>
          <label>
            Date:
            <input
              type="date"
              name="date"
              value={filters.date}
              onChange={handleFilterChange}
            />
          </label>
          <label>
            Month:
            <input
              type="month"
              name="month"
              value={filters.month}
              onChange={handleFilterChange}
            />
          </label>
          <label>
            Customer:
            <input
              type="text"
              name="customer"
              value={filters.customer}
              onChange={handleFilterChange}
            />
          </label>
          <button type="submit">Filter</button>
        </form>
      </div>

      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Sale Price</th>
            <th>Customer</th>
            <th>Sale Date</th>
          </tr>
        </thead>
        <tbody>
          {sales.map((sale) => (
            <tr key={sale._id}>
              <td>{sale.jewelleryItem.name}</td>
              <td>{sale.quantity}</td>
              <td>{sale.salePrice}</td>
              <td>{sale.customer}</td>
              <td>{new Date(sale.saleDate).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SalesList;
